import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { errMsg } from "../../lib/api";
import SEO from "../../components/SEO";
import { inputCls } from "../admin/AFields";

const SERVICES = ["", "facebook", "ai"];

export default function StudioLogs() {
  const [items, setItems] = useState([]);
  const [service, setService] = useState("");

  const load = () => api.get(`/studio/logs${service ? `?service=${service}` : ""}`).then((r) => setItems(r.data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { load(); }, [service]); // eslint-disable-line

  return (
    <div data-testid="studio-logs">
      <SEO title="API Logs" />
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div>
          <h1 className="font-display text-2xl font-bold tracking-tight text-navy sm:text-3xl">API Logs</h1>
          <p className="mt-1 text-sm text-slate-500">Recent external API calls. Sensitive values are masked automatically.</p>
        </div>
        <select value={service} onChange={(e) => setService(e.target.value)} className={`${inputCls} !w-48`} data-testid="logs-service-filter">
          {SERVICES.map((s) => <option key={s} value={s}>{s || "All services"}</option>)}
        </select>
      </div>

      <div className="mt-6 overflow-x-auto rounded-lg border border-gray-200 bg-white">
        <table className="w-full min-w-[680px] text-sm">
          <thead>
            <tr className="border-b border-gray-100 text-left text-xs font-bold uppercase tracking-wider text-slate-500">
              <th className="px-4 py-3">Time</th><th className="px-4 py-3">Service</th><th className="px-4 py-3">Action</th>
              <th className="px-4 py-3">Result</th><th className="px-4 py-3">Detail</th>
            </tr>
          </thead>
          <tbody>
            {items.map((l) => (
              <tr key={l.id} className="border-b border-gray-50" data-testid={`log-row-${l.id}`}>
                <td className="whitespace-nowrap px-4 py-3 text-xs text-slate-500">{String(l.at || "").replace("T", " ").slice(0, 19)}</td>
                <td className="px-4 py-3"><span className="rounded-full bg-navy-50 px-2.5 py-0.5 text-xs font-bold uppercase text-navy">{l.service}</span></td>
                <td className="px-4 py-3 text-xs font-semibold">{l.action}</td>
                <td className="px-4 py-3">{l.ok ? <span className="rounded-full bg-brandgreen-100 px-2.5 py-0.5 text-xs font-bold text-brandgreen">OK</span> : <span className="rounded-full bg-red-50 px-2.5 py-0.5 text-xs font-bold text-red-500">FAILED</span>}</td>
                <td className="max-w-[320px] truncate px-4 py-3 text-xs text-slate-500" title={l.detail}>{l.detail}</td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={5} className="px-4 py-12 text-center text-sm text-slate-400">No API activity yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
